import * as React from 'react';
import { ThemeProvider as EmotionThemeProvider, Global, css } from '@emotion/react';

import { lightTheme, darkTheme } from './index';
import Header from '../Header';
import { baseStyles } from '../styles/GlobalStyles';
import { styles } from '../../custom/styles/styles';

class ThemeProvider extends React.Component {
  state = {
    isDarkThemeActive: false,
  };

  componentDidMount() {
    this.retrieveActiveTheme();
    this.applyViewerClass();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.is2005Viewer !== this.props.is2005Viewer) {
      this.applyViewerClass();
    }
  }

  retrieveActiveTheme = () => {
    const isDarkThemeActive = JSON.parse(window.localStorage.getItem('isDarkThemeActive'));

    this.setState({ isDarkThemeActive });
  };

  toggleActiveTheme = () => {
    this.setState(prevState => ({ isDarkThemeActive: !prevState.isDarkThemeActive }));

    window.localStorage.setItem('isDarkThemeActive', JSON.stringify(!this.state.isDarkThemeActive));
  };

  applyViewerClass = () => {
    if (typeof document === 'undefined') return;
    const { is2005Viewer } = this.props;
    const body = document.body;
    if (is2005Viewer) {
      body.classList.add('nbh-viewer');
    } else {
      body.classList.remove('nbh-viewer');
    }
  };

  render() {
    const { children, location, is2005Viewer } = this.props;

    const { isDarkThemeActive } = this.state;

    const currentActiveTheme = isDarkThemeActive ? darkTheme : lightTheme;

    return (
      <div>
        <Global styles={[baseStyles, ...styles]} />
        <Header
          location={location}
          isDarkThemeActive={isDarkThemeActive}
          is2005Viewer={is2005Viewer}
          toggleActiveTheme={this.toggleActiveTheme}
        />
        <EmotionThemeProvider theme={{ ...currentActiveTheme, isViewer: is2005Viewer }}>{children}</EmotionThemeProvider>
      </div>
    );
  }
}

export default ThemeProvider;
